import BaseModel from '../base/BaseModel.model';
import RecordTag from './recordTag.model';
export default class Record extends BaseModel {

    public name?: string;
    public documentId?: number | null;
    public parentId?: number | null;
    public parent?: Record | null;
    public document?: any | null;
    public recordTags: Array<RecordTag>;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.name = null;
        this.documentId = null;
        this.parentId = null;
        this.parent = null;
        this.document = null;
        this.recordTags = [];
    }
}